// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1LCH3","disabled":"FileBtn_disabled__1w3eU","warn":"FileBtn_warn__1Ypsu","fade":"FileBtn_fade__1NI4V"};